/* unplugin-vue-components disabled */import { render } from "./SubmissionsList.vue?vue&type=template&id=0dd02a24"
import script from "./SubmissionsList.vue?vue&type=script&lang=js"
export * from "./SubmissionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__